/// <reference path="../../_ext/editors/ItemGridEditor.ts" />

namespace TabAurous.ECommerce {
    import fld = Finance.PartyBalanceRow.Fields;
    @Serenity.Decorators.registerClass()
    export class ECommRefundBalanceEditor extends _Ext.ItemGridEditor<Finance.PartyBalanceRow> {
        protected getColumnsKey() { return "ECommerce.ECommRefundBalance"; }
        protected getDialogType() { return Finance.PartyBalanceDialog; }
        protected getLocalTextPrefix() { return Finance.PartyBalanceRow.localTextPrefix; }
        public pendingChanges: Q.Dictionary<any> = {}; 
        editMode: boolean;  
        public amount: number;
        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as ECommRefundDialog).calculatePartyBalance();
                }
            })
        }
        clearCustomerRefund() {

            this.view.setItems([]);
        }
        setCustomerRefund(refunds: Finance.PartyBalanceRow[]) {
            for (let pbalance of refunds ) {
                pbalance[this.getIdProperty()] = "`" + this.nextId++;
                var x = pbalance;
                //alert(x.Amount);
                this.view.addItem(x);
            }

        }
        //add the knock off edit column
        public getColumns() {

            var columns = super.getColumns();
            var num = ctx => ColumnFormatter.AmountFormatter(ctx, this);

            //Q.first(columns, x => x.field === fld.KnockOff).format = num;

            this.view.refresh();
            return columns;
        }

        //validate knock off value
        private inputsChange(e: JQueryEventObject) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;
            if (field === fld.KnockOff) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else {
                value = text;
            }
            if (field === fld.KnockOff && value >= 0) {
                //to check the new entered value is not greater than the total amount
               
                var Knockoffvalue = parseFloat(value);
                var knockoffdone = (this.parentDialog as any).form.KnockOffTotal.value - item.KnockOff;

                var knockoffECommsible = (this.parentDialog as any).form.TotalAmount.value;
                if ((knockoffdone + Knockoffvalue) > knockoffECommsible) {
                    item.Due = item.TotalAmount - 0;
                    item[field] = 0;  
                    this.view.updateItem(id, item);
                    this.view.refresh();
                    Q.alert('Knock off value should be less than Total Amount');
                    return;
                } 
                if (item.TotalAmount >= Knockoffvalue) {
                    if (value <= item.Due) {
                        item.Due = item.TotalAmount - value;
                        item[field] = value;
                    }
                } else {
                    Q.alert('Knock off value should be less than Total Amount'); 
                    return;
                }

            }
            (this.parentDialog as any).calculatePartyBalance();
            this.view.updateItem(id, item);
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }

            return item[field];
        }
        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }



        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var id = this.id(item);
            var target = $(e.target);

            if (target.hasClass('check-box no-float readonly') || target.hasClass('check-box no-float readonly checked'))
                target.removeClass('readonly')

            if (target.hasClass('check-box no-float')) {
                if (item.CheckRefund == true) {
                    item.CheckRefund = false;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                }
                else {
                    item.CheckRefund = true;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                }
                (this.parentDialog as ECommRefundDialog).calculatePartyBalance();


            }

            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Delete record?', () => {

                        this.view.deleteItem(id);
                        this.view.refresh();
                    });
                }
                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }



    }
}